import React, { Component } from 'react';
import {
  TextInput,
  Button,
  DataTable,
  Tabs,
  Tab,
  Table,
  TableContainer,
  CodeSnippetSkeleton,
  TableBody,
  ComboBox,
  Loading,
  DropdownSkeleton,
  FormGroup,
  InlineLoading,
  AccordionItem, //RITM1230723
  Accordion, //RITM1230723
  TextArea, //RITM1230723
  RadioButton, //RITM1230723

} from 'carbon-components-react';
import '../../scss/custom.scss';
import Add16 from '@carbon/icons-react/lib/add/16';
import Save16 from '@carbon/icons-react/lib/save/20';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import { Information16 } from '@carbon/icons-react';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { AppContext } from '../../helpers/context/AppContext';
import { IsEditable } from '../../helpers/authorization/Policies';
import { getError, entitiesLabels, apioperation, getSuccess } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { api, dynamic, registry } from '../../helpers/api/api'; //RITM1197573
import { HistoryTable } from '../../helpers/HistoryTable';
import { WarningModal } from '../common/WarningModal';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import ReportRepository from '../../helpers/api/ReportRepository';
import { Online } from '../common/OnLineOffLine';
import _sortBy from 'lodash/sortBy'; //RITM1197573
import { Collapse } from 'bootstrap';

export default class Safety extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.geqValidator = {
      message: 'The value must be greater than or equal to zero',
      rule: (val, params, validator) => +val >= 0,
    };
    //RITM1230723
    this.gleqValidator = {
      message: 'The value must be greater than or equal to zero and lesser than or equal to 100',
      rule: (val, params, validator) => {return +val >= 0 && +val <= 100},
    };
    //End
    this.laggingIndicatorFormModel = [
      { label: 'Average Manpower', fieldRef: 'averageManpower' },
      { label: 'Worked Manhours', fieldRef: 'workedManhours' },
      { label: 'Fatal Accidents', fieldRef: 'fatalAccidents', precompiled: true },
      { label: 'Lost Time Injuries', fieldRef: 'lostTimeInjuries', precompiled: true },
      { label: 'Work Restricted Cases', fieldRef: 'workRestrictedCases', precompiled: true },
      { label: 'Medical Treatments', fieldRef: 'medicalTreatments', precompiled: true },
      { label: 'First Aid Cases', fieldRef: 'firstAidCases', precompiled: true },
      { label: 'Near Miss P/A', fieldRef: 'nearMissPA', precompiled: true },
      { label: 'Near Miss H&S', fieldRef: 'nearMissHS', precompiled: true },
      { label: 'Near Miss ENV', fieldRef: 'nearMissENV', precompiled: true },
      { label: 'Days Lost', fieldRef: 'daysLost', precompiled: true },
      { label: 'Restricted Work Days', fieldRef: 'restrictedWorkDays', precompiled: true },
      { label: 'Commuting Injuries', fieldRef: 'commutingInjuries', precompiled: true },
      { label: 'Road Traffic Accidents', fieldRef: 'roadTrafficAccidents', precompiled: true },
      { label: 'KM Driven', fieldRef: 'kmDriven' },
    ];
    this.leadingIndicatorFormModel = [
      { label: 'HSE Training Hours', fieldRef: 'hseTrainingHours' },
      { label: 'Job Safety Analysis', fieldRef: 'jobSafetyAnalysis' },
      { label: 'Tool Box Talks', fieldRef: 'toolBoxTalks' },
      { label: 'Senior Management HSE Visits', fieldRef: 'seniorManagementHSEVisits' },
      { label: 'HSE Inspections', fieldRef: 'hseInspections' },
      { label: 'HSE Meetings', fieldRef: 'hseMeetings' },
      { label: 'Drill H&S', fieldRef: 'drillHS' },
      { label: 'Drill ENV', fieldRef: 'drillENV' },
      { label: 'Drill H&S Planned', fieldRef: 'drillHSPlanned' },
      { label: 'Drill ENV Planned', fieldRef: 'drillENVPlanned' },
        { label: 'Hazard Observation Cards   (HOC count grouped by Info Originator to which the selected Employer belongs)', fieldRef: 'hazardObservationCards', precompiled: true },
    ];
    //RTM1230723
    this.BarrierKPIFormModel = [
      { label: '%', fieldRef: 'value' },
      { label: 'NA', fieldRef: 'notApplicable' },
    ]
    //End
    this.state = {
      idReason: null,
      isReasonModalOpen: false,
      reason: null,
      xReasons: [],
      iscompiledBysameUser:false,
      idSubContractor: null,
      isDisabled: true,
      isEmployerModalOpen: false,
      isSubContractorsDropdownVisible: false,
      isOpenInfo: false,
      isLoadingReport: true,
      isLoadingSubContractorOptions: true,
      report: null,
      safetyDataList: [],
      infoOriginators: [],
      subContractorOptions: [],
      selectedSubContractors: [],
      selectedSafetyData: null,
      isEmployerSelected: false,
      isLoadingSubmitted: false,
      isSubmitted: true,
      invalidEmployerForms: [],
      isWarningModalOpen: false,
      isWarningReOpenModalOpen: false,
      isHistoryModalOpen: false,

      isOpenDeleteModal: false,
      isDeleting: false,
      idToDelete: false,
      isLoadingBarrierKPI: false, //RITM1230723
    };
  }

    sortEmployers = (a, b) => {
        var nameA = a.subContractor == null ? 'SAIPEM PERSONNEL' : a.subContractor.toUpperCase();
        var nameB = b.subContractor == null ? 'SAIPEM PERSONNEL' : b.subContractor.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    };

    handleChangeCombo = (inputName, selectedItem, objName) => {
        let inputValue = selectedItem ? selectedItem.id : null;
        let statusCopy = Object.assign({}, this.state[objName]);
        statusCopy[inputName] = inputValue;
        this.setState({ [objName]: statusCopy });
    };

    showButtonHistory = () => (
        <Button
            className="action-button-modal"
            kind="secondary"
            renderIcon={Information16}
            onClick={() => this.openModalHistory()}
        >
            History
        </Button>
    );

    openModalHistory = () => {
        this.setState({ isHistoryModalOpen: true });
    };

    closeModalHistory = () => {
        this.setState({ isHistoryModalOpen: false });
    };

    showDivInfo = () => {
        this.setState((oldState) => ({ isOpenInfo: !oldState.isOpenInfo }));
    };
    getReasons = () => {
        ReportRepository.getReasons(moment.utc(this.state.report.start).format('YYYY'))
            .then((response) => {
                this.setState({
                    xReasons: response,
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.SUBCONTRACTOR, apioperation.get)
                );
            });
   };
    toggleEmployerModal = () => {
        this.setState((oldState) => ({
            idSubContractor: null,
            isSubContractorsDropdownVisible: false,
            isEmployerModalOpen: !oldState.isEmployerModalOpen,
            isEmployerSelected: false,
            infoOriginator: null,
        }));
    };
    toggleReasonModal = () => {
        this.setState((oldState) => ({
            reason: null,
            isReasonModalOpen: !oldState.isReasonModalOpen,
        }));
    };

    showSearchSubC = () => {
        this.setState({
            isSubContractorsDropdownVisible: true,
            isEmployerSelected: false,
        });
    };

    selectNoSubcontractor = () => {
        this.setState({
            isSubContractorsDropdownVisible: false,
            isEmployerSelected: true,
            selectedSubContractors: [],
        });
    };

    onSubContractorSelected = (selectedItems) => {
        if (selectedItems.length > 0) {
            this.setState({
                selectedSubContractors: selectedItems,
                isEmployerSelected: true,
            });
        }
    };

  isCreateSafetyDataDisabled = () =>
    !this.state.infoOriginator ||
   (this.state.infoOriginator.name !== 'Saipem' && !this.state.idSubContractor);

    handleCreateSafetyData = () => {
        let subContractorsSelected = this.state.safetyDataList.filter(
            (x) => x.idSubContractor == this.state.idSubContractor
        );
        if (subContractorsSelected?.length > 0) {
            showNotification.warning(
                `${entitiesLabels.WARNING}`,
                'A report for ' +
                this.state.infoOriginator?.name +
                (subContractorsSelected[0].subContractor != null
                    ? '/' + subContractorsSelected[0].subContractor
                    : '') +
                ' already exists'
            );
        } else {
            let precompiledFields = [];
            ReportRepository.getSafetyComputedField(
                this.props.match.params.idReport,
                this.state.idSubContractor
            ).then((response) => {
                precompiledFields = response;

        if (this.state.idSubContractor == null) {
          // We are creating a new Saipem SafetyData entry, ensuring distinctness
          if (this.state.safetyDataList.map((x) => x.isSaipem).indexOf(true) === -1) {
            const safetyDataList = [...this.state.safetyDataList].concat([
              {
                ...precompiledFields,
                isSaipem: true,
                validator: new SimpleReactValidator({
                  validators: {
                    geq: this.geqValidator,
                  },
                }),
              },
            ]);
            //RITM1230723
            const newsafetyDataList = [...safetyDataList];
            const reportSafetyBarrierKPIDataResultList = newsafetyDataList[newsafetyDataList.length - 1].reportSafetyBarrierKPIData?.map((s) => ({
              ...s,
              validator: new SimpleReactValidator({
                validators: {
                  gleq: this.gleqValidator,
                },
              }),
            })) || [];
            safetyDataList[safetyDataList.length - 1].reportSafetyBarrierKPIData = [...reportSafetyBarrierKPIDataResultList];
            //End
            this.setState((prevState) => ({
              ...prevState,
              safetyDataList,
              selectedSafetyData: safetyDataList[safetyDataList.length - 1],
              infoOriginator: null,
            }));
          }
          //this.submitImmediate(true)
        } else {
          const selectedSubContractors = [];
          if (this.state.idSubContractor != null) {
            selectedSubContractors.push(
              this.state.subContractorOptions.find((el) => el.id === this.state.idSubContractor)
            );
          }

          // We are creating 0 or more sub-contractor SafetyData entries
          const newSafetyDataEntries = selectedSubContractors.map((s) => ({
            ...precompiledFields,
            idSubContractor: s.id,
            subContractor: s.name,
            validator: new SimpleReactValidator({
              validators: {
                geq: this.geqValidator,
              },
            }),
          }));
          //RITM1230723
          const newsafetyDataList = [...newSafetyDataEntries];
          const newSafetyBarrierKPIDataResultList = newsafetyDataList[newsafetyDataList.length - 1].reportSafetyBarrierKPIData?.map((s) => ({
            ...s,
            validator: new SimpleReactValidator({
              validators: {
                gleq: this.gleqValidator,
              },
            }),
          })) || [];
          newSafetyDataEntries[newSafetyDataEntries.length - 1].reportSafetyBarrierKPIData = [...newSafetyBarrierKPIDataResultList];
          //End
          const safetyDataList = [...this.state.safetyDataList].concat([...newSafetyDataEntries]);
          this.setState({
            safetyDataList,
            selectedSafetyData: safetyDataList[safetyDataList.length - 1],
            infoOriginator: null,
          });
        }
        this.toggleEmployerModal();
      });
    }
  };

  divModal() {
    //RITM1197573
    const subContractorsByInfo = this.state.infoOriginator
      ? (this.state.subContractorOptions || []).filter(
          (el) => el.inUse && el.infoOriginator?.id === this.state.infoOriginator?.id
        )
      : [];
    return (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container modal-overflow-visible">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading"> Add New Employer </h3>{' '}
          </div>
          <br></br>
          <div className="bx--row">
            <div className="bx--col-lg-6 bx--col-md-6">
              <FormGroup legendText="Info Originated from*">
                <ComboBox
                  key={'infoOriginator'}
                  id="infoOriginator"
                  placeholder="Select"
                  name="infoOriginator"
                  onChange={(el) =>
                    this.setState({
                      infoOriginator: el.selectedItem,
                      idSubContractor: null,
                    })
                  }
                  itemToString={(item) => (item ? item.name : '')}
                  // items={this.state.infoOriginators}
                  items={this.state.infoOriginators.filter(
                      (item) => item.inUse && item.name !== 'SAP'  )} // Rimuovi l'opzione "SAP" dalla lista //RITM1197573
                  disabled={this.state.isDisabled}
                />
              </FormGroup>
            </div>
            <div className="bx--col-lg-6 bx--col-md-6">
              <FormGroup
                legendText={
                  'SubContractor' + (this.state.infoOriginator?.name === 'Saipem' ? '' : '*')
                }
              >
                <ComboBox
                  key={'subContractor_' + this.state.infoOriginator?.id}
                  id="subContractor"
                  placeholder="Select"
                  name="idSubContractor"
                  onChange={(el) =>
                    this.setState({
                      idSubContractor: el.selectedItem?.id,
                    })
                  }
                  itemToString={(item) => (item ? item.name : '')}
                  items={subContractorsByInfo}
                  shouldFilterItem={({ item, inputValue }) =>
                    item.name.toLowerCase().includes(inputValue.toLowerCase())
                  }
                  disabled={
                    this.state.isDisabled ||
                    this.state.infoOriginator?.name === 'Saipem' ||
                    this.state.infoOriginator == null
                  }
                />
              </FormGroup>
            </div>
          </div>
          <div className="searchFormFooter mt-20">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.toggleEmployerModal}
            >
              Cancel
            </Button>
            <Button
              className="button--max-width"
              kind="primary"
              onClick={this.handleCreateSafetyData}
              disabled={this.isCreateSafetyDataDisabled()}
            >
              Create
            </Button>
          </div>
        </div>
      </div>
    );
  }

    divModalReopenReason() {
        return (<div className="bx--modal bx--modal-tall is-visible">
            <div className="bx--modal-container modal-overflow-visible">
                <div className="bx--modal-header">
                    <h3 className="bx--modal-header__heading"> REASON TO REOPEN </h3>{' '}
                </div>
                <br></br>
                <div className="bx--row">
                    <div className="bx--col-lg-12 bx--col-md-6">
                        {/* below needs change */}<FormGroup
                            legendText="REASON TO REOPEN the REPORT* " >
                            <ComboBox
                                id="idReason"
                                placeholder="Select"
                                name="Reason"
                                alt="Reason"
                                onChange={(el) =>
                                    this.setState({
                                        reason: el.selectedItem?.id
                                    })
                                }
                                itemToString={(item) => (item ? item.name : '')}
                                initialSelectedItem={"Select"}
                                items={this.state.xReasons.filter((x) => x.code == 'ReportSafety')}
                            />
                        </FormGroup>
                    </div>

                </div>
                <div className="searchFormFooter mt-20">
                    <Button
                        className="button--max-width"
                        kind="secondary"
                        onClick={this.toggleReasonModal}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="button--max-width"
                        kind="primary"
                        onClick={this.toggleWarningReOpenModal}
                        disabled={this.state.reason == 'Select' || this.state.reason == null}
                    >
                        Save
                    </Button>
                </div>
            </div>
        </div>
        );
    }

    divInfo() {
        return (
            <div className=" box--informations-all">
                <div className="bx--row box--information show">
                    <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
                        <div className="information--itmes">
                            <div className="information--color ">Start:</div>
                            <div className="notification-module">
                                {moment.utc(this.state.report.start).format('DD/MM/YYYY')}
                            </div>{' '}
                        </div>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
                        <div className="information--itmes">
                            <div className="information--color ">End:</div>
                            <div className="notification-module">
                                {moment.utc(this.state.report.end).format('DD/MM/YYYY')}
                            </div>{' '}
                        </div>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
                        <div className="information--itmes">
                            <div className="information--color ">Compiled by:</div>
                            <div className="notification-module">{this.state.report.compiledBy}</div>{' '}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

  getReport = (refresh) => {
    ReportRepository.getReportSafety(this.props.match.params.idReport)
      .then((response) => {
        response.safetyData.forEach(
          (s) =>
            (s.validator = new SimpleReactValidator({
              validators: {
                geq: this.geqValidator,
              },
            }))
        );
        //RITM1230723
        response.safetyData.forEach(
          (s) => 
            (s.reportSafetyBarrierKPIData.forEach(
              (f) =>
                (f.validator = new SimpleReactValidator({
                validators: {
                  gleq: this.gleqValidator,
                },
              }))
            ))
        );
        //End
        this.setState({
          report: response,
          safetyDataList: response.safetyData,
          isDisabled: !IsEditable(
            'Report',
            'Reporting',
            this.context.user,
            response.idStatus,
            'All',
            response
          ),
        });
        if (refresh && this.state.selectedSafetyData) {
          const selectedItem = (response.safetyData || []).find(
            (el) => el.id === this.state.selectedSafetyData.id
          );
          this.setState({
            selectedSafetyData: selectedItem,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.REPORT, apioperation.GET)
        );
      })
      .finally(() => {
        //RITM1258665
        // this.setState({
        //   isLoadingReport: false,
        //   iscompiledBysameUser: (this.state.report.idCompiler == this.context.user.id),
        // });
        // this.getReasons(); 
        this.setState(
          {
            isLoadingReport: false,
          },
          () => {
              this.getReasons();
              this.setState({
                iscompiledBysameUser: this.state.report.idCompiler == this.context.user.id
              });
          }
        );
        //End
      });
  };

    deleteReportSafetyData = (reportSafetyData) => {
        api
            .deleteData(`reports/safety/${this.props.match.params.idReport}`, { id: reportSafetyData.id })
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        idToDelete: null,
                        isOpenDeleteModal: false,
                    });
                    this.onCloseConfirm();
                    showNotification.success(
                        `${entitiesLabels.SUCCESS}`,
                        getSuccess(entitiesLabels.REPORT, apioperation.DELETE)
                    );
                } else {
                    showNotification.error();
                }
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.REPORT, apioperation.DELETE)
                );
            })
            .finally(() => {
                this.setState({
                    isDeleting: false,
                });
            });
    };
    ReopenReportSafetyData = () => {
        api
            .put(`reports/reopen/${this.props.match.params.idReport}/${this.state.reason}`)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        isWarningReOpenModalOpen: false,
                    });
                    //this.onCloseConfirm();
                    showNotification.success(
                        `${entitiesLabels.SUCCESS}`,
                        getSuccess(entitiesLabels.REPORT, apioperation.PUT)
                    );
                    this.showLoading();
                    this.getReport();
                    
                } else {
                    showNotification.error();
                }
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.REPORT, apioperation.PUT)
                );
            //})
            // .finally(() => {
            //     this.setState({
            //         isDeleting: false,
            //     });
             });
    };

    getSubContractors = () => {
        ReportRepository.getSubcontractors()
            .then((response) => {
                this.setState({
                    subContractorOptions: response,
                });
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.SUBCONTRACTOR, apioperation.get)
                );
            })
            .finally(() => {
                this.setState({
                    isLoadingSubContractorOptions: false,
                });
            });
    };

  getInfoOriginators = () => {
    dynamic
      .getAll('infooriginator', { params: { page: 0 } }) //RITM1197573
      .then((response) => {
        var data = _sortBy(response.data.itemList, "id"); //RITM1197573
        data = data != null ? data.map((item) => ({ id: item.id, name: item.name, inUse: item.inUse })) : []; //RITM1197573
        this.setState({
          infoOriginators: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET)
        );
      })
      .finally(() => {});
    };

    componentDidMount() {
        this.getReport();
        this.getInfoOriginators();
        this.getSubContractors();
                  
    }

    confirmDelete = (id) => {
        this.setState({
            idToDelete: id, // è un oggetto in questo caso
            isOpenDeleteModal: true,
            isDeleting: false,
        });
    };

    onCloseConfirm = () => {
        this.setState({
            isOpenDeleteModal: false,
        });
    };

    deleteItem = () => {
        const valueToRemove = this.state.idToDelete;
        const selectedPersonell = this.state.safetyDataList;

        this.setState({
            isDeleting: true,
        });

        const itemToRemoveIndex = this.state.safetyDataList.indexOf(valueToRemove);
        selectedPersonell.splice(itemToRemoveIndex, 1);

        this.setState({
            safetyDataList: selectedPersonell,
        });

        // se il guid è !null, cancello anche dal backend
        if (valueToRemove.id !== '00000000-0000-0000-0000-000000000000') {
            this.deleteReportSafetyData(valueToRemove);
        } else {
            this.setState({
                idToDelete: null,
                isOpenDeleteModal: false,
                isDeleting: false,
            });
        }
    };

    handleSafetyDataChange = (selectedItem) => {
        const valueToRemove = this.state.selectedSafetyData;

        // se è null c'è una cancellazione da fare
        if (!selectedItem) {
            this.confirmDelete(valueToRemove);
        }

        this.setState({
            selectedSafetyData: selectedItem,
        });
    };

    onInputChange = (field, e) => {
        const safetyDataList = [...this.state.safetyDataList];
        const safetyDataIndex = this.state.safetyDataList.indexOf(this.state.selectedSafetyData);
        const newSafetyData = { ...this.state.safetyDataList[safetyDataIndex] };
        newSafetyData[field] = e.target.value;
        safetyDataList[safetyDataIndex] = newSafetyData;
        this.setState(
            {
                safetyDataList,
                selectedSafetyData: newSafetyData,
            },
            this.updateInvalidFormsList
        );
    };

  updateInvalidFormsList = () => {
    //RITM1230723
    if (this.state.safetyDataList[0].validator.messagesShown || this.state.safetyDataList[0].reportSafetyBarrierKPIData.every((v) => v.validator.messagesShown)) { //RITM1230723
      const invalidEmployerForms = this.state.safetyDataList
        .filter((s) => !s.validator.allValid())
        .map((s) => this.getEmployerName(s)).length > 0 ? this.state.safetyDataList
        .filter((s) => !s.validator.allValid())
        .map((s) => this.getEmployerName(s)) : this.state.safetyDataList
        .filter((s) => s.reportSafetyBarrierKPIData.filter((f) => !f.validator.allValid()).length > 0)
        .map((s) => this.getEmployerName(s));
      this.setState({
        invalidEmployerForms,
      });
    }
    //End
  };

    handleConfirmSubmit = () => {
        this.setState(
            {
                isWarningModalOpen: false,
            },
            () => this.submitReport(true)
        );
    };

    toggleWarningModal = () => {
        this.setState((prevState) => ({
            isWarningModalOpen: !prevState.isWarningModalOpen,
        })); 
    };
    handleConfirmReOpenSubmit = () => {
        this.setState(
            {
                isWarningReOpenModalOpen: false,
            },
            this.toggleReasonModal(),
            this.ReopenReportSafetyData()
            // () => this.submitReport(true)
        );
    };

    toggleWarningReOpenModal = () => {
        this.setState((prevState) => ({
            isWarningReOpenModalOpen: !prevState.isWarningReOpenModalOpen,
        }));        
    };

    downloadFile() {
        if (this.state.isExportLoading) return;

        this.setState({
            isExportLoading: true,
        });
        api
            .getWithParam(`reports/excel/${this.props.match.params.idReport}`, {
                responseType: 'arraybuffer',
            })
            .then((response) => {
                const data = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const csvURL = window.URL.createObjectURL(data);
                const tempLink = document.createElement('a');
                tempLink.href = csvURL;

                const nomefile = `Export_SafetyReport_${this.state.report.progressiveId}_${moment().format(
                    'YYYYMMDDHHmmSS'
                )}.xlsx`;
                tempLink.setAttribute('download', nomefile);

                document.body.appendChild(tempLink);
                tempLink.click();
            })
            .catch((error) => {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, 'Download File', apioperation.GET)
                );
            })
            .finally(() => {
                this.setState({
                    isExportLoading: false,
                });
            });
    }

    submitImmediate = (fillEmptyFields) => {
        const validators = this.state.safetyDataList.map((s) => s.validator);

    const reportDataList = [];
    this.state.safetyDataList.forEach((s) => {
      const { validator, validations, ...safetyDataModel } = s;
      if (fillEmptyFields) {
        this.laggingIndicatorFormModel.concat(this.leadingIndicatorFormModel).forEach((f) => {
          safetyDataModel[f.fieldRef] = safetyDataModel[f.fieldRef] || 0;
          s[f.fieldRef] = s[f.fieldRef] || 0;
        });
      }
      reportDataList.push(safetyDataModel);
    });
    this.setState({ isSubmitted: false, isLoadingSubmitted: true });
    api
      .put('reports/safety/', reportDataList, this.props.match.params.idReport)
      .then(async (response) => {
        await ReportRepository.updateCachedSafety(this.props.match.params.idReport, reportDataList);
        showNotification.success(
          `${entitiesLabels.SUCCESS}`,
          getSuccess(entitiesLabels.REPORT, apioperation.PUT)
        );
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.REPORT, apioperation.PUT)
        );
      })
      .finally(() => {
        this.setState(
          {
            isSubmitted: true,
            isLoadingSubmitted: false,
          },
          () => this.getReport(true)
        );
      });
  };
  submitReport = (fillEmptyFields) => {
    const validators = this.state.safetyDataList.map((s) => s.validator);
    const validatorsBarrierKPIData = this.state.safetyDataList.map((s) => s.reportSafetyBarrierKPIData?.map((f) => f.validator)); //RITM1230723
    if (validators.every((v) => v.allValid()) && validatorsBarrierKPIData.every((vs) => vs.every((v) => v.allValid()))) { //RITM1230723
      if (
        fillEmptyFields ||
        this.state.safetyDataList.every(
          (sd) =>
            this.laggingIndicatorFormModel.every(
              (f) => sd[f.fieldRef] !== undefined && sd[f.fieldRef] !== ''
            ) &&
            this.leadingIndicatorFormModel.every(
              (f) => sd[f.fieldRef] !== undefined && sd[f.fieldRef] !== ''
            )
        )
      ) {
        validators.every((v) => v.hideMessages());
        validatorsBarrierKPIData.every((vs) => vs.every((v) => v.allValid())) //RITM1230723
        const reportDataList = [];
        this.state.safetyDataList.forEach((s) => {
          const reportBarrierKPIDataList = []; //RITM1230723
          const { validator, validations, ...safetyDataModel } = s;
          if (fillEmptyFields) {
            this.laggingIndicatorFormModel.concat(this.leadingIndicatorFormModel).forEach((f) => {
              safetyDataModel[f.fieldRef] = safetyDataModel[f.fieldRef] || 0;
              s[f.fieldRef] = s[f.fieldRef] || 0;
            });
          }
          //RITM1230723
          safetyDataModel.reportSafetyBarrierKPIData.forEach((f) => {
            const { validator, validations, ...reportSafetyBarrierKPIDataModel } = f;
            reportBarrierKPIDataList.push(reportSafetyBarrierKPIDataModel)
          })
          safetyDataModel.reportSafetyBarrierKPIData = [...reportBarrierKPIDataList];
          //End
          reportDataList.push(safetyDataModel);
        });
        this.setState({ isSubmitted: false, isLoadingSubmitted: true });
        api
          .put('reports/safety/', reportDataList, this.props.match.params.idReport)
          .then(async (response) => {
            await ReportRepository.updateCachedSafety(
              this.props.match.params.idReport,
              reportDataList
            );
            showNotification.success(
              `${entitiesLabels.SUCCESS}`,
              getSuccess(entitiesLabels.REPORT, apioperation.PUT)
            );
          })
          .catch((error) => {
            showNotification.error(
              `${entitiesLabels.ERROR}`,
              getError(error, entitiesLabels.REPORT, apioperation.PUT)
            );
          })
          .finally(() => {
            this.setState(
              {
                isSubmitted: true,
                isLoadingSubmitted: false,
              },
              () => this.getReport(true)
            );
          });
      } else {
        this.toggleWarningModal();
      }
    } else {
      validators.forEach((v) => v.showMessages());
      validatorsBarrierKPIData.forEach((vs) => vs.forEach((v) => v.showMessages())); //RITM1230723
      this.updateInvalidFormsList();
    }
  };

  //RITM1230723
  getSections = () => {
    const result = [];
    const map = new Map();
    (this.state.selectedSafetyData.reportSafetyBarrierKPIData || []).map((item)=> {
      if (!map.has(item.barrierKPI.section)) {
        map.set(item.barrierKPI.section, true);
        result.push(item);
      }
    });
    return result.sort((a, b) => a.barrierKPI.ranking - b.barrierKPI.ranking);
  };
  getBarrierKPI = (sectionName) => {
    const result = [];
    (this.state.selectedSafetyData.reportSafetyBarrierKPIData || []).map((item) => {
      if (item.barrierKPI.section === sectionName)
        result.push(item);
    });
    return result.sort((a, b) => a.ranking - b.ranking);
  };
  onInputChangeBarrierIndicator = (idBarrierKPI, field, e, value) => {
    if(field === 'kpiNotes')
        e.preventDefault();
    const safetyDataList = [...this.state.safetyDataList];
    const safetyDataIndex = this.state.safetyDataList.indexOf(this.state.selectedSafetyData);
    const newSafetyData = { ...this.state.safetyDataList[safetyDataIndex] };
    const result = [];
    (newSafetyData.reportSafetyBarrierKPIData || []).map((item) => {
      if (item.barrierKPI.id === idBarrierKPI)
      {
        if (field === 'notApplicable')
        {
          item[field] = value;
          item["value"] = '';
        }
        else if (field === 'value')
        {
          item[field] = e.target.value;
          item["notApplicable"] = null;
        }
        else
          item[field] = e.target.value;
        result.push(item);
      }
      else
        result.push(item);
    });
    newSafetyData.reportSafetyBarrierKPIData = result;
    safetyDataList[safetyDataIndex] = newSafetyData;
    this.setState(
      {
        safetyDataList,
        selectedSafetyData: newSafetyData,
      },
      this.updateInvalidFormsList
    );
  };
  onSectionNoteChange(sectionName, field, note) {
    note.preventDefault();
    const safetyDataList = [...this.state.safetyDataList];
    const safetyDataIndex = this.state.safetyDataList.indexOf(this.state.selectedSafetyData);
    const newSafetyData = { ...this.state.safetyDataList[safetyDataIndex] };
    const result = [];
    (newSafetyData.reportSafetyBarrierKPIData || []).map((item) => {
      if (item.barrierKPI.section === sectionName)
      {
        item[field] = note.target.value;
        result.push(item);
      }
      else
        result.push(item);
    });
    newSafetyData.reportSafetyBarrierKPIData = result;
    safetyDataList[safetyDataIndex] = newSafetyData;
    this.setState(
      {
        safetyDataList,
        selectedSafetyData: newSafetyData,
      },
    );
  };

  showBarrierKPI = () => {
    this.setState({
      isLoadingBarrierKPI: true,
    });
  };
  //End

  renderIndicatorForm = (formModel) => (
    <TableContainer>
      <Table>
        <TableBody>
          {formModel.map((f) => (
            <tr className="description-items-list">
              <td> {f.label} </td>
              <td className="bx--cell-input">
                <TextInput
                  className="cell--item"
                  value={this.state.selectedSafetyData[f.fieldRef]}
                  onChange={(e) => this.onInputChange(f.fieldRef, e)}
                  type="number"
                  min="0"
                  step="1"
                  labelText=""
                  onKeyDown={(e) => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()}
                  disabled={this.state.isDisabled || f.precompiled}
                  invalid={this.state.selectedSafetyData.validations[f.fieldRef] != null}
                />
                {this.state.selectedSafetyData.validations[f.fieldRef]}
              </td>
            </tr>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  renderTabs = () => {
    if (this.state.selectedSafetyData) {
      return (
        <div className="bx--row mt-20 tabs--custom report-tabs">
          <Tabs
            selected={0}
            tabContentClassName="bx-table-all-view"
            key={this.state.safetyDataList.indexOf(this.state.selectedSafetyData)}
          >
            <Tab disabled={false} label="Lagging Indicators">
              <DataTable
                key="dt1"
                className="datatable-information-layout"
                rows={[]}
                headers={[]}
                useZebraStyles
                render={() => this.renderIndicatorForm(this.laggingIndicatorFormModel)}
              />
            </Tab>
            <Tab disabled={false} label="Leading  Indicators">
              <DataTable
                key="dt2"
                className="datatable-information-layout"
                rows={[]}
                headers={[]}
                useZebraStyles
                size="compact"
                render={() => this.renderIndicatorForm(this.leadingIndicatorFormModel)}
              />
            </Tab>
            {/* RITM1230723 */}
            {this.state.selectedSafetyData.reportSafetyBarrierKPIData?.length > 0 ? (
            <Tab
              href="#"
              label={`Barrier Indicators`}
              className={"datatable-information-layout"} //RITM0937302
              onClick={() => this.showBarrierKPI()}
              onKeyDown={() => {}}
              role="presentation"
              selected={false}
            >
              {this.state.isLoadingBarrierKPI ? (
                <div className="some-content">
                  <Accordion>
                      {this.getSections().map((item) => (
                          <AccordionItem
                                      className="auditAccordionTitle"
                                      title={` ${item.barrierKPI.section}`}
                                      id={item.barrierKPI.id}
                                      key={item.barrierKPI.id}
                                    >
                                      <div className="bx--row main-information-itmes">
                                        <div  className='bx--col-lg-7 bx--col-md-7'>
                                        </div>
                                        <div  className='bx--col-lg-5 bx--col-md-5'>
                                          <fieldset className="bx--fieldset">
                                                <TextArea
                                                  maxLength={5000}
                                                  labelText=""
                                                  className="some-class"
                                                  cols={50}
                                                  disabled={this.state.isDisabled}
                                                  light={false}
                                                  onChange={(note) => this.onSectionNoteChange(item.barrierKPI.section, 'sectionNotes', note, null)}
                                                  placeholder="Do you have any additional Barrier/ KPI to propose?"
                                                  rows={2}
                                                  value={item.sectionNotes || ''}
                                                />
                                          </fieldset>
                                      </div>
                                    </div>
                                    <div className="bx--row safetybarrierindicators" >
                                      <TableContainer>
                                        <table className="bx--data-table">
                                            <thead className="colorgray">
                                              <tr>
                                                <th>
                                                    <span className="bx--table-header-label">KPI Description</span>
                                                </th>
                                                <th>
                                                    <span className="bx--table-header-label">Barrier Group</span>
                                                </th>
                                                <th>
                                                    <span className="bx--table-header-label">Barriers</span>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.getBarrierKPI(item.barrierKPI.section).map((kpi) => (
                                                    <tr key={`tr${kpi.barrierKPI.id}`} id={`tr${kpi.barrierKPI.id}`}>
                                                        <td className="bx--cell" style={{width:'45%', whiteSpace: "pre-wrap"}}>{kpi.barrierKPI.description}</td>
                                                        <td className="bx--cell" style={{width:'10%', flexWrap:"wrap"}}>{kpi.barrierKPI.incidentBarrierGroups}</td>
                                                        <td className="bx--cell" style={{width:'15%', flexWrap:"wrap"}}>{kpi.barrierKPI.incidentBarriers}</td>
                                                        <td className="bx--cell-input" style={{width:'5%'}}> 
                                                            <TextInput
                                                                className="cell--item"
                                                                value={kpi.value || ''}
                                                                onChange={(e) => this.onInputChangeBarrierIndicator(kpi.barrierKPI.id, 'value', e, null)}
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                                step="1"
                                                                hideLabel="true"
                                                                placeholder='%'
                                                                onKeyDown={(e) => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()}
                                                                disabled={this.state.isDisabled}
                                                                invalid={kpi.validations['value'] != null}
                                                              />
                                                              {kpi.validations['value']}
                                                        </td>
                                                        <td className="bx--cell-input" style={{width:'5%'}}>
                                                            <RadioButton
                                                                className="some-class"
                                                                id={`btnNA${kpi.barrierKPI.id}`}
                                                                key={`btnNA${kpi.barrierKPI.id}`}
                                                                onClick={(e) => this.onInputChangeBarrierIndicator(kpi.barrierKPI.id, 'notApplicable', e, 1)}
                                                                labelText="NA"
                                                                value={kpi.notApplicable}
                                                                disabled={this.state.isDisabled}
                                                                checked={kpi.notApplicable != null}
                                                                invalid={kpi.validations['notApplicable'] != null}
                                                            /> 
                                                            {kpi.validations['notApplicable']}
                                                        </td>
                                                        <td className="bx--cell-input" style={{width:'20%'}}>
                                                            <TextArea
                                                                maxLength={5000}
                                                                labelText=""
                                                                className="some-class"
                                                                cols={50}
                                                                disabled={this.props.isDisabled}
                                                                light={false}
                                                                onChange={(e) => this.onInputChangeBarrierIndicator(kpi.barrierKPI.id, 'kpiNotes', e)}
                                                                placeholder="Note"
                                                                rows={2}
                                                                value={kpi.kpiNotes}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))} 
                                            </tbody>
                                        </table>
                                      </TableContainer>
                                    </div>  
                          </AccordionItem>
                        ))}
                  </Accordion>
                </div>
              ) : null}
            </Tab>
            ) : null}
            {/* End */}
          </Tabs>
        </div>
      );
    }
    return (
      <div className="bx--row mt-20 no-employer box-information-detail-no-result">
        <div className="bx--col">No Employer selected</div>
      </div>
    );
  };

    getEmployerName = (safetyData) =>
        safetyData.isSaipem ? 'Saipem personnel' : safetyData.subContractor;

  renderSubContractorItem = (item) => (
    <div
      className={(!item.validator.allValid() && item.validator.messagesShown) 
        || (item.reportSafetyBarrierKPIData.filter((f) => !f.validator.allValid()).length > 0 && item.reportSafetyBarrierKPIData.every((v) => v.validator.messagesShown)) ? 'invalid-item' : ''} //RITM1230723
    >
      {item ? this.getEmployerName(item) : ''}
    </div>
  );

    showLoading() {
        const show = !this.state.isSubmitted;
        const descr = !this.state.isSubmitted ? 'Saving...' : 'Loading data...';
        return show && <Loading active withOverlay description={descr} />;
    }

    render() {
        this.state.safetyDataList.forEach((s) => {
            s.validations = this.laggingIndicatorFormModel
                .concat(this.leadingIndicatorFormModel)
                .reduce((acc, cur) => {
                    let validationCode = 'geq';
                    if (this.state.selectedSafetyData === s) {
                        validationCode += '|required|integer';
                    }
                    acc[cur.fieldRef] = s.validator.message(cur.label, s[cur.fieldRef], validationCode);
                    return acc;
                }, {});
        });

    //RITM1230723
    this.state.safetyDataList.forEach((s) => {
      s.reportSafetyBarrierKPIData.forEach((f) => {
        f.validations = this.BarrierKPIFormModel
          .reduce((acc, cur) => {
            if (cur.fieldRef === 'value')
            {
              let validationCode = 'gleq';
              if (this.state.selectedSafetyData === s) {
                validationCode += '|required|integer';
              }
              acc[cur.fieldRef] = f.validator.message(cur.label, f['value'] || f['notApplicable'], validationCode);
            }
            else
              acc[cur.fieldRef] = f.validator.message(cur.label, f['value'] || f['notApplicable'], 'required');
            return acc;
          }, {});
      });
    });
    //End

    const getNameDelete = (id) => {
      if (id == null) return '';
      return this.getEmployerName(id);
    };

        const confirmDelProps = () => ({
            idToDelete: this.state.idToDelete,
            nameItem: getNameDelete(this.state.idToDelete),
            isDeleting: this.state.isDeleting,
            open: this.state.isOpenDeleteModal, // open state
            onCloseConfirm: this.onCloseConfirm, // no click
            deleteItem: this.deleteItem, // yes click fn()
        });

        return (
            <div>
                <PageBreadCrumb
                    linkTo={`/reportSummaries/${this.props.match.params.idReportSummary}`}
                    linkText="Report Summary"
                    titleLeft="Report Safety"
                    titleCenter={this.state.report && `ID: ${this.state.report.progressiveId}`}
                    titleRight={this.state.report && this.state.report.status}
                    showButtonHistory={this.showButtonHistory()}
                />
                <div className="mainContainer">
                    {this.showLoading()}
                    <ConfirmAlertCustom {...confirmDelProps()} />
                    <div className="bx--grid content full-width mainContainer ">
                        {!this.state.isLoadingReport ? (
                            <Online>
                                <HistoryTable
                                    entityId={this.state.report?.id}
                                    isOpenModal={this.state.isHistoryModalOpen}
                                    onClose={() => this.closeModalHistory()}
                                />
                            </Online>
                        ) : (
                            ''
                        )}
                        {this.state.isLoadingReport ? (
                            <CodeSnippetSkeleton type="multi" />
                        ) : (
                            <>
                                <div className="mt-20">{this.divInfo()}</div>
                            </>
                        )}

                        <div className="bx--row description-big-title mt-20 description-big-title-custom">
                            <div className="bx--col- box-modal-content-costum">
                                <div className="box-modal-content-costum-toolbar">
                                    <div className="bx--col-lg-2 bx--col-md-2 combo-label">
                                        <h5 className="information--detail ">Select an employer:</h5>
                                    </div>

                                    <div className="bx--col-lg-6  bx--col-md-6 multi--search box-modal-content-costum-title">
                                        {this.state.isLoadingReport ? (
                                            <div className="with-action">
                                                <DropdownSkeleton />
                                            </div>
                                        ) : (
                                            <div className="combo-action-container">
                                                <ComboBox
                                                    id="Pickanemployer"
                                                    className="description-information-left"
                                                    placeholder="Pick an employer..."
                                                    items={this.state.safetyDataList.sort(this.sortEmployers) || []}
                                                    onChange={({ selectedItem }) => this.handleSafetyDataChange(selectedItem)}
                                                    itemToElement={(item) => this.renderSubContractorItem(item)}
                                                    itemToString={(item) =>
                                                        item ? (item.isSaipem ? 'Saipem Personnel ' : item.subContractor) : ''
                                                    }
                                                    selectedItem={this.state.selectedSafetyData}
                                                />
                                                <h5>or</h5>
                                                <Button
                                                    className="button-actions-table"
                                                    size="default"
                                                    renderIcon={Add16}
                                                    onClick={this.toggleEmployerModal}
                                                    disabled={this.state.isDisabled}
                                                    iconDescription="Add Personal Employer"
                                                    tooltipPosition="top"
                                                    tooltipAlignment="center"
                                                >
                                                    <span>Add New Employer</span>
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* RITM1510731 */}
                                    <div className="bx--col-lg-4 bx--col-md-8 button--items button-row box-modal-content-costum-title" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    {this.state.report && (this.state.xReasons.length > 0) && ((this.state.report.status == 'Completed' && this.state.iscompiledBysameUser)||(this.state.report.status != 'Opened' && this.context.user.roles.includes('Administrator'))) ? 
                                            (<Button
                                                renderIcon={Save16}
                                                className="pull--left"
                                                onClick={this.toggleReasonModal}
                                                style={{ marginRight: "12px" }} //RITM1510731
                                            >
                                                <span>ReOpen</span>

                                            </Button>):(<h1></h1>) }
                                        <Button
                                            renderIcon={Save16}
                                            className="pull--right"
                                            onClick={() => this.submitReport(false)}
                                            disabled={this.state.isDisabled || this.state.isLoadingSubmitted}
                                        >
                                            {this.state.isSubmitted ? (
                                                <span>Save</span>
                                            ) : (
                                                <InlineLoading className="short-loader" />
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            {this.state.invalidEmployerForms.length &&
                                this.state.safetyDataList &&
                                this.state.safetyDataList.length > 0 &&
                                this.state.safetyDataList[0].validator.messagesShown ? (
                                <div className="bx--row mt-50 box-modal-content-costum-span ">
                                    <div className="bx--col">
                                        <span className="srv-validation-message pull--right">
                                            The following employer reports contain erroneous fields:
                                            {` ${this.state.invalidEmployerForms.join(', ')}`}
                                        </span>
                                    </div>
                                </div>
                            ) : null}

                            {this.renderTabs()}
                        </div>
                        {!this.state.isReasonModalOpen ? '' : this.divModalReopenReason()}
                        {!this.state.isEmployerModalOpen ? '' : this.divModal()}
                        {this.state.isWarningReOpenModalOpen ? (
                            <WarningModal
                                message="Are you sure that you want to reopen the report?"
                                onCancel={this.toggleWarningReOpenModal}
                                onConfirm={this.handleConfirmReOpenSubmit}
                            />
                        ) : null}
                        {this.state.isWarningModalOpen ? (
                            <WarningModal
                                message="Some Employer records contain empty fields. If you choose to continue, all such fields will be set to zero."
                                onCancel={this.toggleWarningModal}
                                onConfirm={this.handleConfirmSubmit}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

Safety.contextType = AppContext;
